export default __webpack_public_path__ + "static/media/b_slide5.b2db297d.jpg";